import React from 'react';
import { Route } from 'react-router-dom';
import WebViewProvider from './context/web-view-context';

function WebViewRoute({ component: Component, title, banner, ...rest }) {
  document.title = `${title} | ${banner}`;
  return (
    <WebViewProvider>
      <Route {...rest} render={(props) => <Component {...props} />} />
    </WebViewProvider>
  );
}

export default WebViewRoute;
